import React, {Component} from 'react';
import {Input,Form} from "antd";
import BaseComponent from "../../../../base/BaseComponent";

class TaskDetail extends BaseComponent {
    constructor(props) {
        super(props);
        this.state={
            title: props.itemValue || "",
        }
    }
    componentDidMount() {
    }


    render() {
        return (
            <div id={'releaseMedia'}>
                <Form.Item label={this.props.label} labelCol={{span: 3}} style={{display:'flex'}}>
                    <p style={{marginTop:10,lineHeight: 1.5}}>{this.props.itemValue&&this.props.itemValue.map(item=>item.name).join('、')}</p>
                </Form.Item>
            </div>

        );
    }

}

export default TaskDetail